module.exports = __webpack_public_path__ + "static/media/1.f587a07b.JPG";